import React from 'react'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'
import NewSpendingDemandForm from '../../../features/spendingDemand/components/NewSpendingDemandForm/NewSpendingDemandForm'
import styles from './UpdateSpendingDemandPage.module.scss'

export default function UpdateSpendingDemandPage() {
  return (
    <PageLayout 
      title="Demande de dépenses"
      showBackButton
      backButtonLinkToIfNoHistory="/spending_demand"
    >
      <div className={styles['page__content']}>
        <div className={styles['page__content__form']}>
          <NewSpendingDemandForm isUpdate={true} />
        </div>
      </div>
    </PageLayout>
  )
}
